import { render, staticRenderFns } from "./ForgotPassword.vue?vue&type=template&id=c379130e&scoped=true&"
import script from "./ForgotPassword.vue?vue&type=script&lang=js&"
export * from "./ForgotPassword.vue?vue&type=script&lang=js&"
import style0 from "./ForgotPassword.vue?vue&type=style&index=0&id=c379130e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c379130e",
  null
  
)


    import installComponents from "!/Users/dhulsman/Projects/rentmagic.website.vue.defietsambassadegent/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BAlert, BCol, BFormInput, BFormGroup, BButton, BRow, BForm, BCard, BContainer} from 'bootstrap-vue'
    installComponents(component, {BAlert, BCol, BFormInput, BFormGroup, BButton, BRow, BForm, BCard, BContainer})
    

export default component.exports